import eyeIcon from "../Assets/icons/eye 1.svg";
import editIcon from "../Assets/icons/Un-Checkbox.svg";

export const TABLE_HEADERS = [
  "PO No.",
  "PO Date",
  "PO Type",
  "Payment term",
  "Payment Mode",
  "Created Date",
  "Action",
];

export const TABLE_DATA = [
  {
    id: 1,
    leadId: "1045",
    customerName: "Pinky Gupta",
    conatctNo: "+919833456896",
    visitDateAndTime: "2023-08-11:30 am",
    loaction: "Thane, Mumbai",
    product: "Scooter",
    make: "TVS Apache",
    model: "RTR 160",
    variant: "Rear Drum",
    color: "Black",
    actions: "Edit/Delete",
  },
  {
    id: 2,
    leadId: "1046",
    customerName: "Pinky Gupta",
    conatctNo: "+919833456896",
    visitDateAndTime: "2023-08-11:30 am",
    loaction: "Thane, Mumbai",
    product: "Scooter",
    make: "TVS Apache",
    model: "RTR 160",
    variant: "Rear Drum",
    color: "Black",
    actions: "Edit/Delete",
  },
  {
    id: 3,
    leadId: "1047",
    customerName: "Pinky Gupta",
    conatctNo: "+919833456896",
    visitDateAndTime: "2023-08-11:30 am",
    loaction: "Thane, Mumbai",
    product: "Scooter",
    make: "TVS Apache",
    model: "RTR 160",
    variant: "Rear Drum",
    color: "Black",
    actions: "Edit/Delete",
  },
  {
    id: 4,
    leadId: "1048",
    customerName: "Pinky Gupta",
    conatctNo: "+919833456896",
    visitDateAndTime: "2023-08-11:30 am",
    loaction: "Thane, Mumbai",
    product: "Scooter",
    make: "TVS Apache",
    model: "RTR 160",
    variant: "Rear Drum",
    color: "Black",
    actions: "Edit/Delete",
  },
  {
    id: 5,
    leadId: "1049",
    customerName: "Pinky Gupta",
    conatctNo: "+919833456896",
    visitDateAndTime: "2023-08-11:30 am",
    loaction: "Thane, Mumbai",
    product: "Scooter",
    make: "TVS Apache",
    model: "RTR 160",
    variant: "Rear Drum",
    color: "Black",
    actions: "Edit/Delete",
  },
  {
    id: 6,
    leadId: "1050",
    customerName: "Pinky Gupta",
    conatctNo: "+919833456896",
    visitDateAndTime: "2023-08-11:30 am",
    loaction: "Thane, Mumbai",
    product: "Scooter",
    make: "TVS Apache",
    model: "RTR 160",
    variant: "Rear Drum",
    color: "Black",
    actions: "Edit/Delete",
  },
];

export const keyMapping = {
 "PO No.":"po_number",
  "PO Date":"po_date",
  "PO Type":"potype",
  "Payment term":"payment_term_name",
  "Payment Mode":"payment_mode",
  "Created Date":"created_at",
  "Status":"status",
  Action: [
    // { type: "edit", icon: editIcon, label: "Edit" },
    { type: "view", icon: eyeIcon, label: "View" },
  ],
};

// export const topDataList = [
//   { id: 1, title: "Total Quotations", value: "180" },
//   { id: 2, title: "Pending Approvals", value: "170" },
//   { id: 3, title: "Approved Quotations", value: "8" },
//   { id: 4, title: "Rejected Quotations", value: "2" },
//   { id: 5, title: "Approval Rate", value: "98%" },
// ];
